// profiles.store.js
import { observable, computed, action } from "mobx";

import { axios } from "../../utils/axios";

// const { NotificationManager } = require("react-notifications");
import { v4 as uuidv4 } from "uuid";

// TODO: Missing reference module files - these classes are stub implementations
// import {
//     Reference,
//     ReferenceQuizObjects,
// } from "./references/quiz-reference";

// import FetchedReference from "./references/fetched_reference";
// import { reference } from "prop-types";

// Stub class implementations until modules are available
class Reference {
    _id: string = "";
    constructor(...args: any[]) {}
    setField(field: string, value: any): void {}
}

class ReferenceQuizObjects {}

class FetchedReference {
    slug: string = "";
    updated: number = 0;
    constructor(slug?: string, updated?: number) {
        if (slug) this.slug = slug;
        if (updated) this.updated = updated;
    }
}

export default class ReferencesStore {
    @observable references: any = new Map();
    @observable reference: any = {};
    @observable state = "pending"; // "pending" / "done" / "error"
    @observable fetched_references: Array<any> = [];
    @observable fetch_in_progress: { [key: string]: boolean } = {};

    rootStore: any;

    constructor(rootStore: any) {
        this.rootStore = rootStore;
    }

    @action.bound
    fetch_references() {
        if (!this.rootStore.profileStore.authTokenSet()) {
            return;
        }

        this.state = "pending";
    }

    @action.bound
    save(reference: Reference, cb: Function) {
        var store = this;
        axios()
            .put(`/references/${reference._id}`, reference)
            .then(function(res: any) {
                store.references.set(
                    reference._id,
                    new Reference(
                      store.rootStore, reference._id, res.data.reference)
                );
                cb(false, res.data.data);
            })
            .catch(function(err: any) {
                if (!err.response || !err.response.data) {
                    return console.log(err);
                }

                if (err.response.data.duplicate == "title") {
                    cb(true, "emailError", "Object Title Already Taken");
                }
                if (err.response.data.auth) {
                    cb(true, "authError", "Can't edit that subject.");
                }
                if (err.response.data.message) {
                    cb(
                        true,
                        "Missing Informaion",
                        err.response.data.message[0].msg,
                        ""
                    );
                }
            });
    }

    @action.bound
    createFromReference(reference: any, cb: Function) {
        var store = this;

        return axios()
            .post(
                `/subjects/${reference.subject.user}/${reference.subject.slug}/references`,
                {
                    title: reference.title
                }
            )
            .then(function(res: any) {
                let new_quiz_obj = res.data.reference;
                reference._id = res.data.reference._id;
                if (cb) cb(false, new_quiz_obj);
            })
            .catch(function(err: any) {
                store.rootStore.uiStore.flashMessage = err;
                if (err.response) {
                    if (err.response.data.duplicate == "title") {
                        cb(false, "emailError", "Object Title Already Taken");
                    }
                    if (err.response.data.auth) {
                        cb(false, "authError", "Can't edit that subject.");
                    }
                }
                if (cb) cb(true, {});
            });
    }

    @action.bound
    create(
        subject_user: string,
        subject_slug: string,
        title: string,
        url: string,
        cb: Function
    ) {
        var store = this;
        return axios()
            .post(`/subjects/${subject_user}/${subject_slug}/references`, {
                title: title
            })
            .then(function(res: any) {
                let new_quiz_obj = res.data.reference;
                store.rootStore.subjectStore.addObject(
                    subject_user,
                    subject_slug,
                    new_quiz_obj
                );

                store.references.set(
                    new_quiz_obj._id,
                    new Reference(
                      store.rootStore, new_quiz_obj.slug, new_quiz_obj)
                );
                if (cb) cb(false, new_quiz_obj);
            })
            .catch(function(err: any) {
                store.rootStore.uiStore.flashMessage = err;
                if (err.response) {
                    if (err.response.data.duplicate == "title") {
                        cb(false, "emailError", "Object Title Already Taken");
                    }
                    if (err.response.data.auth) {
                        cb(false, "authError", "Can't edit that subject.");
                    }
                }
                if (cb) cb(true, {});
            });
    }

    @action
    delete(ReferenceToDelete: any, cb: Function) {
        var store = this;
        axios()
            .delete(`/references/${ReferenceToDelete._id}`)
            .then(function(res: any) {
                let tempMap = new Map();
                for (let Reference of store.references) {
                    if (Reference[0] !== ReferenceToDelete._id) {
                        tempMap.set(Reference[0], Reference[1]);
                    }
                }

                store.references = tempMap;
                cb(false, res.data.reference);
            })
            .catch(function(err: any) {
                if (err) {
                    console.log(err);
                }
                store.rootStore.uiStore.flashMessage = err;
                cb(true);
            });
    }


    @action
    setReference(field: string, reference_id: string, value: string) {
        let reference = this.references.get(reference_id);
        this.references.get(reference_id).setField(field, value);
        reference[field] = value;
        this.references.set(reference_id, reference);
    }

    addNewEmptyObject(subject: any) {
        let uuid = uuidv4();

        let newReference = new Reference(
          this.rootStore, uuid, {
            subject: subject,
            new: true
        });

        console.log("Before add new empty Object");
        console.log(this.references);
        this.references.set(uuid, newReference);

        this.rootStore.subjectStore.addObject(
            subject.user,
            subject.slug,
            newReference,
            uuid
        );
    }

    fetchOne(user: string, subject: string, reference_slug: string) {
        var subject_hash_key: string = `${user}/${subject}`;
        if (this.fetch_in_progress[reference_slug]) {
            return false;
        }

        this.fetch_in_progress[reference_slug] = true;

        var store = this;

        var fetched_reference_list = this.fetched_references.map(function(
            fetched_reference
        ) {
            return fetched_reference.slug;
        });

        if (fetched_reference_list.includes(reference_slug)) {
            return false;
        }

        axios()
            .get(`/subjects/${subject_hash_key}/references/${reference_slug}`)
            .then(function(res: any) {
                if (res.status === 403) {
                    window.location.href = "/login";
                }

                return res.data;
            })
            .then(function(body: any) {
                store.fetch_in_progress[reference_slug] = false;
                store.references.set(
                    body._id,
                    new Reference(
                        reference_slug, body)
                );
                store.fetched_references.push({
                    slug: reference_slug,
                    updated: Date.now()
                });
            })
            .catch(function(err: any) {
                console.log(err);
                store.fetch_in_progress[reference_slug] = false;
                // NotificationManager.warning(
                //     "Click to Dismiss",
                //     "There was a problem retrieving this reference.",
                //     5000
                // );
                store.state = "error";
            });
    }

    fetchByID(reference_id: string) {
        if (this.fetch_in_progress[reference_id]) {
            return false;
        }

        this.fetch_in_progress[reference_id] = true;

        var store = this;

        axios()
            .get(`/references/${reference_id}`)
            .then(function(res: any) {
                if (res.status === 403) {
                    window.location.href = "/login";
                }

                return res.data;
            })
            .then(function(body: any) {
                store.references.set(
                    reference_id,
                    new Reference(
                        reference_id,
                        body.reference,
                        body.tracking
                    )
                );
                store.fetched_references.push({
                    slug: reference_id,
                    updated: Date.now()
                });

                store.fetch_in_progress[reference_id] = false;
            })
            .catch(function(err: any) {
                store.fetch_in_progress[reference_id] = false;
                // NotificationManager.warning(
                //     "Click to Dismiss",
                //     "There was a problem retrieving this reference.",
                //     5000
                // );
                store.state = "error";
            });
    }

    get_current_reference() {
        var reference_slug = this.rootStore.uiStore.reference_detail_slug;

        return this.references.get(reference_slug);
    }
}
